import { useRef } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const DraggableHeaderCell = ({
  dragId,
  children,
  style: cellStyle,
  className: cellClassName,
  ...restProps
}) => {
  const fallbackId = useRef(`__nd_${Math.random()}`);

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: dragId || fallbackId.current });

  if (!dragId) {
    return (
      <th style={cellStyle} className={cellClassName} {...restProps}>
        {children}
      </th>
    );
  }

  const style = {
    ...cellStyle,
    transform: CSS.Transform.toString(
      transform ? { ...transform, scaleY: 1 } : null
    ),
    transition,
    userSelect: "none",
    position: "relative",
    ...(isDragging && { zIndex: 999, opacity: 0.85 }),
  };

  return (
    <th
      {...restProps}
      ref={setNodeRef}
      style={style}
      className={`${cellClassName || ""} draggable-col${
        isDragging ? " is-dragging" : ""
      }`.trim()}
      {...attributes}
      {...listeners}
    >
      {children}
    </th>
  );
};

export default DraggableHeaderCell;
